import { useMutation, useQueryClient } from "@tanstack/react-query";
import { bulkUpdateRows } from "@services/subscriberSyncUpload";

export function useBulkDecideSubscriberSyncRows(options: any = {}) {
  const queryClient = useQueryClient();

  return useMutation(bulkUpdateRows, {
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["subscriberSyncUpload", variables.uploadId],
      });
    },
    ...options,
  });
}
